import AnimalChart from "./AnimalChart";

export default AnimalChart;
